import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useRef } from 'react';
import { EVENT_PREFIX } from '../constants/events';
// Create the context with undefined as default
export const WidgetEventsContext = createContext(undefined);
/**
 * Provider component for widget events
 * Makes event communication available to child components
 */
export const WidgetEventsProvider = ({ children, eventManager, }) => {
    // Keep track of handler references for cleanup
    const handlersRef = useRef(new Map());
    /**
     * Function to emit events to the host application
     */
    const emitToHost = (eventName, eventData) => {
        // Add app prefix to indicate this event came from the widget app
        eventManager.emit(`${EVENT_PREFIX.APP}${eventName}`, eventData);
    };
    /**
     * Function to register event listeners for host events
     */
    const onHostEvent = (eventName, handler) => {
        // Add host prefix to only listen for events coming from the host
        const prefixedEventName = `${EVENT_PREFIX.HOST}${eventName}`;
        // Store reference to the handler
        const handlerId = `${prefixedEventName}_${handler.toString()}`;
        handlersRef.current.set(handlerId, handler);
        // Register with event manager using the prefixed name
        eventManager.on(prefixedEventName, handler);
        // Return cleanup function
        return () => {
            eventManager.off(prefixedEventName, handler);
            handlersRef.current.delete(handlerId);
        };
    };
    /**
     * Function to register one-time event listeners
     */
    const onceHostEvent = (eventName, handler) => {
        // Add host prefix to only listen for events coming from the host
        const prefixedEventName = `${EVENT_PREFIX.HOST}${eventName}`;
        // Store reference to the handler
        const handlerId = `${prefixedEventName}_${handler.toString()}_once`;
        handlersRef.current.set(handlerId, handler);
        // Register with event manager using the prefixed name
        eventManager.once(prefixedEventName, handler);
        // Return cleanup function that may be used if component unmounts before event fires
        return () => {
            eventManager.off(prefixedEventName, handler);
            handlersRef.current.delete(handlerId);
        };
    };
    // Context value to be provided
    const contextValue = {
        emitToHost,
        onHostEvent,
        onceHostEvent,
    };
    return (_jsx(WidgetEventsContext.Provider, { value: contextValue, children: children }));
};
//# sourceMappingURL=WidgetEventsContext.js.map